export default "__VITE_ASSET__BvZiJvfE__"